"use strict";

var _ = require('lodash');
module.exports = /*@ngInject*/function ($scope, $location, ProgramService, ProfileService, ConfigService) {
  var ctrl = this;
  ctrl.config = ConfigService.getConfig();
  ctrl.roles = [{
    type: 'ADMIN'
  }, {
    type: 'INSPECTOR'
  }];
  ctrl.currentUser = ProfileService.getProfile();
  ctrl.selectProgram = function (program) {
    if (program._id) {
      ProgramService.get({
        id: program._id
      }, function (result) {
        ctrl.selectedProgram = result;
        ctrl.formAction = null;
      });
    }
  };
  ctrl.selectMember = function (member) {
    var user = _.find(ctrl.selectedProgram.members, function (person) {
      return person.userId === member.userId;
    });
    // eslint-disable-next-line no-param-reassign
    member = user || member;

    // eslint-disable-next-line no-undef
    ctrl.selectedMember = angular.extend({}, ctrl.selectedMember, angular.copy(member));
  };
  ctrl.hasRole = function (member, role) {
    return !!member && !!member.roles && member.roles.length > 0 && _.some(member.roles, {
      type: role.type
    });
  };
  ctrl.selectRole = function (value, member, role) {
    if (value) {
      member.roles.push(role);
    } else {
      _.remove(member.roles, function (r) {
        return role.type === r.type;
      });
    }
  };
  ctrl.addMember = function () {
    ctrl.formAction = 'ADD';
    ctrl.selectedMember = {
      roles: []
    };
    ctrl.member = undefined;
  };
  ctrl.editMember = function (member) {
    ctrl.formAction = 'EDIT';
    // eslint-disable-next-line no-undef
    ctrl.selectedMember = angular.copy(member);
    // eslint-disable-next-line no-undef
    ctrl.member = angular.copy(member);
  };
  ctrl.deleteMember = function (member) {
    ctrl.formAction = 'DELETE';
    // eslint-disable-next-line no-undef
    ctrl.selectedMember = angular.copy(member);
    // eslint-disable-next-line no-undef
    ctrl.member = angular.copy(member);
  };
  ctrl.actionCancel = function () {
    ctrl.formAction = null;
    ctrl.selectedMember = null;
  };
  ctrl.actionSave = function (form, member) {
    if (form.$valid) {
      ctrl.progress = true;
      ProgramService.upsertMember({
        id: ctrl.selectedProgram._id,
        memberId: member.userId
      }, member).$promise.then(function (result) {
        ctrl.selectedProgram = result;
      })["finally"](function () {
        ctrl.progress = false;
        ctrl.actionCancel();
      });
    }
  };
  ctrl.actionDelete = function (form, member) {
    ctrl.progress = true;
    ProgramService.removeMember({
      id: ctrl.selectedProgram._id,
      memberId: member.userId
    }).$promise.then(function (result) {
      ctrl.selectedProgram = result;
    })["finally"](function () {
      ctrl.progress = false;
      ctrl.actionCancel();
    });
  };
  ctrl.hasPermissionToEditYourself = function (member) {
    return ProfileService.isSuperUser() || !ProfileService.isCurrentUser(member);
  };
  ctrl.initFirst = true;
  $scope.$watch(function () {
    return $location.search();
  }, function (newSearch, oldSearch) {
    if (newSearch.program !== oldSearch.program || ctrl.initFirst) {
      ctrl.initFirst = false;
      ctrl.selectProgram({
        _id: $location.search().program
      });
      ctrl.formAction = undefined;
    }
  }, true);
};